import {ManualBackupFormState} from './ManualBackupForm-State'
import {errorsList, errorsPresent, mergeServerValidationErrors} from '../../../../helpers/ErrorHelper'
import {isObject} from "../../../../helpers/DataHelper";
import {endOfURL} from "../../../../helpers/UrlHelper";

export default function manualBackupFormReducer(state = ManualBackupFormState, action) {

    let {data} = {...state};
    let {
        validationErrors,
        name,
        value,
        error,
    } = action;
    switch (action.type) {

        case 'ON-MANUAL-BACKUP-FORM-CHANGE':
            data.payload[name] = value;
            data.message=``;
            data.dispatchAPI = false;
            data.submitted = false;
            buildErrors();
            return {...state, data};

        case 'SET-MANUAL-BACKUP-ERROR':
            data.message = error && error.errors ? error.errors.name[0] : ``;
            buildErrors();
            return {...state, data};

        case 'CANCEL-MANUAL-BACKUP-FORM-DISPATCH':
            data.dispatchAPI = false;
            data.submitted = false;
            buildErrors();
            return {...state, data};

        case 'SET-DEFAULT-MANUAL-BACKUP-FORM':
            data = {
                payload: {
                    name: '',
                },
                errors: [],
                errorsPresent: false,
                submitted: false,
                dispatchAPI: false,
                mode: endOfURL(),
                message: ``
            };
            buildErrors();
            return {...state, data};

        case 'ON-MANUAL-BACKUP-FORM-SUBMIT':
            data.submitted = true;
            buildErrors();
            if (!data.errorsPresent) data.dispatchAPI = true;
            return {...state, data};

        case 'MANUAL-BACKUP-FORM-SERVER-VALIDATION-ERRORS':
            validationErrors && isObject(validationErrors) &&
            Object.keys(validationErrors).map(key =>
                data.errors[key] = [{message: ` ${validationErrors[key][0]}`}]
            );
            data.errorsPresent = true;
            data.dispatchAPI = false;
            return {...state, data};

        default:
            return state
    }

    function buildErrors() {
        data.errors = errorsList(errors)
        data.errorsPresent = errorsPresent(errors)
    }

    function errors(field) {
        let {payload, submitted, validationErrors} = data;
        let errors = {};
        Object.keys(payload).map(key => errors[key] = []);

        errors = mergeServerValidationErrors(errors, validationErrors)

        return field ? errors[field] : errors

        function newError(field, step, message) {
            errors && errors[field].push({step, message})
        }

        function _(field) {
            return data.payload[field]
        }
    }
}